import { BtmReturnRequestStatus, BuildBtmReturnRequestStatusFromString } from "./btm-return-request-status";

export interface IBtmReturnRequestListItem {
    returnRequestId: string;
    declarationId: string;
    orderId: string;
    parcelNumber: string;
    operationCode: string;
    status: string;
    returnType: string;
    returnCategory: string;
    carrier: string;
    customerFirstName: string;
    customerLastName: string;
    inspectedDeclaredItemsQuantity: number;
    declaredItemsToBeInspectedQuantity: number;
    unexpectedItemsInspectedQuantity: number;
    returnDemandCode: string;
}

export class BtmReturnRequestListItem {
    private readonly _returnRequestId: string;
    private readonly _declarationId: string;
    private readonly _orderId: string;
    private readonly _parcelNumber: string;
    private readonly _operationCode: string;
    private readonly _status: BtmReturnRequestStatus;
    private readonly _returnType: string;
    private readonly _returnCategory: string;
    private readonly _carrier: string;
    private readonly _customerFirstName: string;
    private readonly _customerLastName: string;
    private readonly _inspectedDeclaredItemsQuantity: number;
    private readonly _declaredItemsToBeInspectedQuantity: number;
    private readonly _unexpectedItemsInspectedQuantity: number;
    private readonly _returnDemandCode: string;

    constructor(dto: IBtmReturnRequestListItem) {
        this._returnRequestId = dto.returnRequestId;
        this._declarationId = dto.declarationId;
        this._orderId = dto.orderId;
        this._parcelNumber = dto.parcelNumber;
        this._operationCode = dto.operationCode;
        this._status = BuildBtmReturnRequestStatusFromString(dto.status);
        this._returnType = dto.returnType;
        this._returnCategory = dto.returnCategory;
        this._carrier = dto.carrier;
        this._customerFirstName = dto.customerFirstName;
        this._customerLastName = dto.customerLastName;
        this._inspectedDeclaredItemsQuantity = dto.inspectedDeclaredItemsQuantity;
        this._declaredItemsToBeInspectedQuantity = dto.declaredItemsToBeInspectedQuantity;
        this._unexpectedItemsInspectedQuantity = dto.unexpectedItemsInspectedQuantity;
        this._returnDemandCode = dto.returnDemandCode ?? "";
    }

    get returnRequestId() {
        return this._returnRequestId;
    }

    get declarationId() {
        return this._declarationId;
    }

    get orderId() {
        return this._orderId;
    }

    get parcelNumber() {
        return this._parcelNumber;
    }

    get operationCode() {
        return this._operationCode;
    }
    get status() {
        return this._status;
    }

    get returnType() {
        return this._returnType;
    }

    get returnCategory() {
        return this._returnCategory;
    }

    get carrier() {
        return this._carrier;
    }

    get customerName() {
        return `${this._customerFirstName} ${this._customerLastName}`;
    }

    get inspectedDeclaredItemsQuantity() {
        return this._inspectedDeclaredItemsQuantity;
    }

    get isInspectionInProgress() {
        return this._inspectedDeclaredItemsQuantity > 0 || this._unexpectedItemsInspectedQuantity > 0;
    }

    get declarationItemsCount() {
        return this._inspectedDeclaredItemsQuantity + this._declaredItemsToBeInspectedQuantity;
    }

    get returnDemandCode() {
        return this._returnDemandCode;
    }
}
